var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQtestLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 101.05 100.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa5d00;stroke:#fa5d00;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8 15.4a21.63 21.63 0 0 0-5.3 3.6c-5.3 5-5.5 6.3-5.5 45.1 0 38 .1 38.9 4.9 44.2 5 5.6 6.1 5.7 45.6 5.7 35.8 0 36.2 0 40.5-2.3a14.27 14.27 0 0 0 6.7-6.8c4.4-8.5 7-7.9-34.4-8-41.1 0-42.7-.2-45.5-5.9-1.6-3-1.8-6.6-1.8-27 0-35.2-1.2-34 34-34 34.6 0 34-.6 34 30.2V80h16V54c0-27.5-.2-29.1-4.9-34.3-5.1-5.6-6.1-5.7-45.5-5.6-25.7 0-36.9.4-38.8 1.3z",
    className: "cls-1",
    transform: "translate(-13.5 -13.58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 47.4c-1.6 1.1-1.8 3.1-1.8 14.8C48 79.8 47.2 79 65.5 79c11.9 0 14-.2 15.1-1.8 2-2.5 1.9-27.8 0-29.8s-28.3-2-30.8 0z",
    className: "cls-1",
    transform: "translate(-13.5 -13.58)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQtestLogo);
export default __webpack_public_path__ + "static/media/qtest-logo.db95464e5ef02407033d2bec2ba8514f.svg";
export { ForwardRef as ReactComponent };